import { BlacksmithLogomarkAnimationSVG } from "./BlacksmithLogoSVG";

/** Shared by the Suspense fallback and redirect stubs so the anvil stays up until the destination commits. */
export function MainPaneLoader() {
  return (
    <div
      data-slot="sidebar-main-loading"
      className="flex h-full items-center justify-center"
    >
      <div className="w-32 h-32">
        <BlacksmithLogomarkAnimationSVG />
      </div>
    </div>
  );
}
